import { DateTime } from 'luxon'
import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'

import { useToBigNumber } from '~/hooks/useToBigNumber'
import { toNumber } from '~/lib/helpers'
import { ADDITIONAL_WEEK, MAX_VESIS_WEEKS } from '~/lib/constants'

export function useConfirmLockParams() {
	const [searchParams] = useSearchParams()

	const amount = searchParams.get('amount') ?? ''

	let weeks = toNumber(searchParams.get('weeks'))
	if (weeks < MAX_VESIS_WEEKS) {
		weeks += ADDITIONAL_WEEK // add 1 week when create lock
	}

	const amountBN = useToBigNumber(amount)

	const expires = useMemo(() => DateTime.now().plus({ weeks }), [weeks])

	return {
		amount,
		amountBN,
		expires,
		weeks,
	}
}
